import React, { ForwardedRef } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/forms/icon.component';

const LabelWithIcon = React.forwardRef(
  (
    {
      type = 'primary',
      title = '',
      subtitle = '',
      textIcon = '',
      icon = '',
      required = false,
      optional = false,
      className = '',
      longDescription = ''
    }: any,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const { t } = useTranslation();

    return (
      <div className={`d-flex flex-stack mb-7 ${className}`} ref={ref}>
        <span className="d-flex align-items-center me-2">
          <span className="symbol symbol-circle symbol-50px me-6">
            <span className={`symbol-label bg-light-${type}`}>
              <Icon icon={icon} size="fs-2x" type={type} />
              {textIcon && <span className={`text-${type} fw-bolder fs-3`}>{textIcon}</span>}
            </span>
          </span>
          <span className="d-flex flex-column">
            <h2 className="fw-bold">
              {title}
              {required && (
                <>
                  {' '}
                  <span className="required"></span>
                </>
              )}
              {optional && (
                <span className="fs-6 ms-1 text-info fw-bolder">({t('general.optional')})</span>
              )}
            </h2>
            <div className="fw-semibold fs-6">{subtitle}</div>
            <div className="fs-6 mt-2">{longDescription}</div>
          </span>
        </span>
      </div>
    );
  }
);

export default LabelWithIcon;
